import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';

import FormInputCollection from '../../../common/FormInputCollection/FormInputCollection';
import { shortDateFormat } from '../../../../utils/Format';
import { btnBorderBlue, btnBorderGreen } from '../styles/dashboardStyles';

export default function FilterControls({ from, to, setFrom, setTo, onSearch, onRefresh }) {
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <FormInputCollection alignLabel={'left'}>
          <DatePicker
            label='From'
            value={from ? moment(from) : null}
            onChange={(d) => setFrom(d ? d.toDate() : null)}
            format={shortDateFormat}
            slotProps={{ textField: { size: 'small' } }}
            sx={{ maxWidth: '180px', marginRight: '5px' }}
          />

          <DatePicker
            label='To'
            value={to ? moment(to) : null}
            onChange={(d) => setTo(d ? d.toDate() : null)}
            format={shortDateFormat}
            slotProps={{ textField: { size: 'small' } }}
            sx={{ maxWidth: '180px' }}
          />
        </FormInputCollection>
      </LocalizationProvider>

      <button style={btnBorderBlue} onClick={onSearch} title='Search'>
        <SearchIcon />
      </button>

      <button style={btnBorderGreen} onClick={onRefresh} title='Refresh'>
        <RefreshIcon />
      </button>
    </div>
  );
}
